export default class DirtyValueCalculator {
    private _originalHashValue: number;
    private static NullHash = DirtyValueCalculator.computeHash(null);
    private static EmptyStringHash = DirtyValueCalculator.computeHash("");
    private static FalseValueHash = DirtyValueCalculator.computeHash(false);

    setOriginalValue(value: unknown): void {
        this._originalHashValue = DirtyValueCalculator.computeHash(value);
    }

    isDirty(currentValue: unknown): boolean {
        const valueHash = DirtyValueCalculator.computeHash(currentValue);

        if (
            typeof currentValue === "boolean" &&
            this._originalHashValue === DirtyValueCalculator.NullHash &&
            valueHash === DirtyValueCalculator.FalseValueHash
        ) {
            return false;
        }

        if (
            typeof currentValue === "string" &&
            this._originalHashValue === DirtyValueCalculator.NullHash &&
            valueHash === DirtyValueCalculator.EmptyStringHash
        ) {
            return false;
        }

        return valueHash !== this._originalHashValue;
    }

    private static computeHash(value: unknown): number {
        return DirtyValueCalculator.getStringHash(`${typeof value}_${JSON.stringify(value)}`);
    }

    private static getStringHash(str: string): number {
        let hash1 = 5381;
        let hash2 = 52711;
        let i = str.length;

        while (i--) {
            const char = str.charCodeAt(i);
            hash1 = (hash1 * 33) ^ char;
            hash2 = (hash2 * 33) ^ char;
        }

        return ((hash1 >>> 0) << 12) + (hash2 >>> 0);
    }
}

export { DirtyValueCalculator };
